import { useEffect } from 'react';
import toast from 'react-hot-toast';

const ENV = process.env['NEXT_PUBLIC_VERCEL_ENV'];

const renderString = (id: string, string: string) => {
  return ENV !== 'production' ? `(${id}): ${string}` : string;
};

export default function AsyncToast({
  loading,
  error,
  id,
  onSuccess = () => {},
  onError = () => {},
  loadingText = 'Loading...',
  successText = 'Done',
}) {
  useEffect(() => {
    console.log('Updating async toast', loading, error, id);
    if (loading) {
      toast.loading(renderString(id, loadingText), {
        id: id,
      });
    } else if (error) {
      toast.error(typeof error === 'string' ? error : 'Failed!', {
        id: id,
      });
      onError();
    } else {
      if (id != 'booking-tile') {
        toast.success(renderString(id, successText), {
          id: id,
        });
      }
      onSuccess();
    }

    return () => {
      toast.dismiss(id);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading, error]);

  return <div className="fixed"></div>;
}
